import { ReactNode } from "react";

type CardProps = {
    children: ReactNode;
    className?: string;
};

export default function Card({ children, className = '' }: CardProps) {
    return (
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
            {children}
        </div>
    )
}

Card.Content = ({ children }: CardProps) => {
    return <div className={`px-4 py-5 sm:p-6 `}>{children}</div>;
};

Card.Footer = ({ children }: CardProps) => {
    return <div className={`px-4 py-4 sm:px-6`}>{children}</div>;
};